//#region
import { Injectable, Inject, DOCUMENT } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { GenericService } from '../../common/common.service';
import { UtilityService } from '../../common/utility.service';

@Injectable()
export class DashboardService {
  public getApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();

  private hostname: string;
  private documentURL: string;
  private urlAarray: string[];
  private baseURL: string;

  dataToShare: any[] = [];

  constructor(@Inject(DOCUMENT) private document: any, public __oUtilityService: UtilityService, private service: GenericService) {
  }


  //Authenticate user
  authenticateUser(): Observable<string> {
    return this.service.getAuthenticate();
  }

  //Get power BI/SSRS reports URL to show it on dashboard screen
  getReportURLs(): any {
    let reportURLs: any = {};
    let myAlerts: any = [{
      'Name': 'https://singapore.demo.cubelogic.com/powerbireports/powerbi/Bank%20Scoring/Bank%20Scoring%20Model?rs:Embed=true'
    }];

    let myPortfolio: any = [{
      'Name': 'https://singapore.demo.cubelogic.com/powerbireports/powerbi/Standard%20Reports%20Power%20PI/Group%20Exposure?rs:Embed=true'
    }]
    reportURLs.myAlerts = myAlerts;
    reportURLs.myPortfolio = myPortfolio;
    return reportURLs;
  }

  //Get system settings
  getSystemSettings(Id: number): Observable<any[]> {
    return this.service.getDataByObservable(this.getApiUrl + "api/PortalMenu/GetSystemSetting/'" + Id + "' ");
  }

  //Get dashboard homepage tabs by user id
  getDashBoardHomepageTabs(userId: number): Observable<any[]> {
    return this.service.getDataByObservable(this.getApiUrl + "api/PortalMenu/DashBoardHomepageTabs/" + userId + " ");
  }

  //Save dashboard homepage tabs by user id
  saveDashBoardHomepageTabs(dashBoardHomepageTabViewModels: any[]): Observable<any> {
    return this.service.UpdateAllDataByObservable(dashBoardHomepageTabViewModels, this.getApiUrl + "api/PortalMenu/DashBoardHomepageTabs");
  }


  postHTMLFromSSRSReport(oHomePageTab: any): Observable<any[]> {
    return this.service.postDataByObservable(oHomePageTab, this.getApiUrl + "api/PortalMenu/SSRSToHTML");
  }

 


}
